"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.Ref = exports.Prop = exports.Watch = exports.Observable = void 0;
require("reflect-metadata");
// SALVO decorators
var Observable_1 = require("./Observable");
Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return Observable_1.Observable; } });
var Watch_1 = require("./Watch");
Object.defineProperty(exports, "Watch", { enumerable: true, get: function () { return Watch_1.Watch; } });
var Prop_1 = require("./Prop");
Object.defineProperty(exports, "Prop", { enumerable: true, get: function () { return Prop_1.Prop; } });
var Ref_1 = require("./Ref");
Object.defineProperty(exports, "Ref", { enumerable: true, get: function () { return Ref_1.Ref; } });
var Component_1 = require("./Component");
Object.defineProperty(exports, "Component", { enumerable: true, get: function () { return Component_1.Component; } });
//# sourceMappingURL=index.js.map